module.exports = __webpack_public_path__ + "static/media/movie.7ad68c42.svg";